<ng-template #modalContent>
  <form [formGroup]="form" (submit)="onSubmit()" class="technical-contacts-modal__form">
    <div class="d-flex flex-column">
      <udex-select-box
        *ngIf="isDepartmentToggleEnabled && isNeedToShowContactType()"
        (selection-change)="onSelect($event)"
        [label]="'checkout.digitalNativeCheckout.newContact.type' | cxTranslate"
        #contractType
      >
        <udex-select-box-item
          *ngFor="let type of contactTypes | keyvalue"
          [value]="type.value"
          [label]="typeOptionLabel(type.value) | async"
          [selected]="selectedType === type.value"
        >
        </udex-select-box-item>
      </udex-select-box>

      <udex-message-strip
        *ngIf="error"
        design="Negative"
        status-type="None"
        hide-close-button
        class="udex-my-20"
        data-cy="error-message"
      >
        <p class="udex-ps-16 udex-py-16">
          <ng-container [ngSwitch]="error.status">
            <ng-container *ngSwitchCase="400">
              <ng-container *ngTemplateOutlet="unexpectedEmailDomain"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="406">
              <ng-container *ngTemplateOutlet="unexpectedEmailDomain"></ng-container>
            </ng-container>
            <ng-container
              *ngSwitchCase="409">{{ 'checkout.digitalNativeCheckout.newContact.error.emailAlreadyExist' | cxTranslate }}
            </ng-container>
            <ng-container
              *ngSwitchDefault>{{ 'checkout.digitalNativeCheckout.newContact.error.somethingWrong' | cxTranslate }}
            </ng-container>
          </ng-container>
          <ng-template #unexpectedEmailDomain>
            {{ 'checkout.digitalNativeCheckout.newContact.error.unexpectedEmailDomain' | cxTranslate }}
            <dcp-contact-us-button
              (click)="closeModal()"
              [isButton]="false"
              [errorMessage]="error.message"
              buttonText="checkout.digitalNativeCheckout.newContact.error.support"
              class="d-inline"
            ></dcp-contact-us-button>.
          </ng-template>
        </p>
      </udex-message-strip>

      <udex-text-field
        required
        *ngIf="selectedType === contactTypes.Individual"
        [value]="getFormControl('firstName').value"
        [label]="'registration.label.firstName' | cxTranslate"
        [supportingText]="isMaxLengthError('firstName') ? (getErrorMessage('firstName') | cxTranslate: { maxLength: getMaxLength('firstName') }) : (getErrorMessage('firstName') | cxTranslate)"
        [valueState]="getErrorStatus('firstName')"
        (input)="onInputChange($event, 'firstName')"
        [class.udex-mt-20]="isDepartmentToggleEnabled"
      ></udex-text-field>

      <udex-text-field
        required
        [value]="getFormControl('lastName').value"
        [label]="lastNameLabel() | async | titlecase"
        [supportingText]="isMaxLengthError('lastName') ? (getErrorMessage('lastName') | cxTranslate: { maxLength: getMaxLength('lastName') }) : (getErrorMessage('lastName') | cxTranslate)"
        [valueState]="getErrorStatus('lastName')"
        (input)="onInputChange($event, 'lastName')"
        class="udex-mt-20"
      ></udex-text-field>

      <udex-text-field
        required
        [value]="getFormControl('email').value"
        [label]="'checkout.digitalNativeCheckout.email' | cxTranslate"
        [supportingText]="isMaxLengthError('email') ? (getErrorMessage('email') | cxTranslate: { maxLength: getMaxLength('email') }) : (getErrorMessage('email') | cxTranslate)"
        [valueState]="getErrorStatus('email')"
        (input)="onInputChange($event, 'email')"
        class="udex-mt-20"
      ></udex-text-field>

      <udex-checkbox
        class="udex-mt-16"
        data-cy="consent-checkbox"
        wrapping-type="Normal"
        [text]="'checkout.digitalNativeCheckout.addTechnicalContactConsent' | cxTranslate"
        [checked]="isConsentCheckboxChecked"
        [valueState]="getCheckboxValueState()"
        (change)="onCheckboxChange(isConsentCheckboxChecked)"
      ></udex-checkbox>
    </div>
    <div class="d-flex justify-content-start udex-py-20">
      <udex-button design="Primary" data-cy="submit-btn" size="Large" (click)="onSubmit()">
        <span
          *ngIf="!isLoading; else showSpinner">{{ "checkout.digitalNativeCheckout.createNew.create" | cxTranslate }}</span>
        <ng-template #showSpinner>
          <span>
          <ui5-busy-indicator
            size="Medium"
            class="white-dots d-flex"
            active></ui5-busy-indicator>
        </span>
        </ng-template>
      </udex-button>

      <udex-button
        class="udex-ms-20"
        data-cy="close-btn"
        design="Secondary"
        size="Large"
        [disabled]="isLoading || (newContactCreated | async)"
        (click)="closeModal()"
      >
        {{ 'common.cancel' | cxTranslate }}
      </udex-button>
    </div>
  </form>
</ng-template>
